import React from 'react';
import { MarketplaceOrderOnHoldViewStore } from 'modules/order/stores';
import { MarketplaceOrderOnHoldTemplate } from 'themes/modules/order/pages';
import { setCurrentView } from 'core/utils';

@setCurrentView(
	(rootStore, componentProps) => new MarketplaceOrderOnHoldViewStore(rootStore, componentProps),
	'marketplaceOrderOnHoldViewStore'
)
class MarketplaceOrderOnHold extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		return <MarketplaceOrderOnHoldTemplate {...this.props} />;
	}
}

export default MarketplaceOrderOnHold;
